import _ from 'lodash'

const getComponentName = (Component, addendum) => {
  const name = Component.displayName || Component.name || 'Component'

  return _.compact([name, addendum]).join('.')
}

export default getComponentName
